export const hoverEffect = {
  "&:hover": {
    backgroundColor: "#f3f5f6",
  },
};

export const navHeightPixel: string = "64px";
